import React from 'react';
import { AutoInsightsProvider } from '@store/autoInsights';
import Drawer from './Drawer';

function Wrapper() {
  return (
    <AutoInsightsProvider>
      <Drawer />
    </AutoInsightsProvider>
  );
}

export default Wrapper;
